/* eslint-disable react/display-name*/
import {
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import Grid from "@mui/material/Grid";
import db from "../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../utils/API";
import VendorCrud from "./VendorCrud.jsx";
import VendortransactionList from "./VendorTransactions.jsx";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export default function VendorList(props) {
  const { t } = useTranslation();
  const translate = t;
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rowLimitPerPage, setRowLimitPerPage] = useState(
    Math.round((getWindowDimensions().height - 155) / 32)
  );
  const [searchStr, setSearchStr] = useState("");

  useEffect(() => {
    loadData();
  }, []);

  function addVendor() {
    biRef.child.showVendorCrudWindow(null);
  }

  function onEditClicked(row) {
    biRef.child.showVendorCrudWindow(row.tableData[row.rowIndex].id);
  }

  async function loadData() {
    loadByRest(0, rowLimitPerPage, "[]", "[]");
    //loaadByDB();
  }
  async function loadByRest(curPage, pageSize, sort, filter) {
    setIsLoading(true);

    const result = await API.get(
      "/api/v1/vendors?range=" +
        encodeURIComponent(
          "[" + curPage * pageSize + "," + ((curPage + 1) * pageSize - 1) + "]"
        ) +
        "&filter=" +
        encodeURIComponent(filter) +
        "&sort=" +
        encodeURIComponent(sort)
    );

    var arr = result.headers["content-range"].split("/");

    const opt = { ...option };
    opt.count = parseInt(arr[2]);
    setOption(opt);
    setData(result.data);
    setIsLoading(false);
  }

  async function loaadByDB() {
    db.vendor.toArray(function (data) {
      setData(data);
    });
  }

  async function onTableChange(tableState) {
    console.log(tableState.searchText);
    let sort = "[]";
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    let search = "[]";
    if (tableState.searchText) {
      let str = "[";
      str = str + '{id:"name",value:"' + tableState.searchText + '"}';
      str = str + ',{id:"code",value:"' + tableState.searchText + '"}';
      str = str + ',{id:"contact1",value:"' + tableState.searchText + '"}';
      str = str + ',{id:"trnNo",value:"' + tableState.searchText + '"}';

      str = str + "]";
      search = str;
    }
    loadByRest(tableState.page, rowLimitPerPage, sort, search);
  }

  function onHistoryClicked(row) {
    console.log("fetch vendor Transactions: " + row.tableData[row.rowIndex].id);
    biRef.transactions.showTransactionList(
      row.tableData[row.rowIndex].id,
      row.tableData[row.rowIndex].ledgerId,
      row.tableData[row.rowIndex].name
    );
  }

  const options = {
    serverSide: true,
    viewColumns: false,
    filter: false,
    download: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: getWindowDimensions().height - 155,
    rowsPerPage: Math.round((getWindowDimensions().height - 155) / 30),
    rowsPerPageOptions: [
      Math.round((getWindowDimensions().height - 155) / 30),
      10,
      15,
      50,
      100,
    ],
    print: false,
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want

      switch (action) {
        case "changePage":
          onTableChange(tableState);
          break;
        case "sort":
          onTableChange(tableState);
          break;
        case "changeRowsPerPage":
          onTableChange(tableState);
          break;
        case "search":
          onTableChange(tableState);
          break;
        default:
        //console.log("action not handled." + action);
      }
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={translate("Refresh Data")}>
            <IconButton
              size="small"
              color="primary"
              onClick={vendorListRefresh}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={translate("Add New Vendor")}>
            <IconButton size="small" color="secondary" onClick={addVendor}>
              <AddIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      );
    },
  };

  const [option, setOption] = useState(options);

  const columns = [
    {
      name: "code",
      label: translate("Code"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "name",
      label: translate("Name"),
      options: {
        filter: false,
        sort: true,
      },
    },

    {
      name: "trnNo",
      label: translate("TRN Number"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "contact1",
      label: translate("Contact"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "action",
      label: translate("Actions"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({ align: "right" }),
        setCellProps: () => ({ align: "right" }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            <Button
              onClick={() => onEditClicked(tableMeta, updateValue, value)}
              color="secondary"
              style={{
                margin: 0,
                padding: 0,
                height: 17,
                width: 27,
                alignText: "right",
              }}
            >
              {props.context.privileges.vendor_edit
                ? translate("Edit")
                : translate("View")}
            </Button>

            {/*<Button
              onClick={() => onHistoryClicked(tableMeta, updateValue, value)}
              color="secondary"
              style={{
                margin: 0,
                padding: 0,
                height: 17,
                width: 27,
                alignText: "center",
              }}
            >
              Ledger
            </Button>*/}
            <VendortransactionList biRef={biRef} />
          </div>
        ),
      },
    },
  ];

  function vendorListRefresh() {
    loadData();
  }

  var biRef = {};

  return (
    <Grid container>
      <Grid item xs={12}>
        <div>
          <MUIDataTable
            title={
              <Typography variant="h6">
                {translate("Vendor List")}
                {isLoading && (
                  <CircularProgress
                    size={24}
                    style={{ marginLeft: 15, position: "relative", top: 4 }}
                  />
                )}
              </Typography>
            }
            data={data}
            columns={columns}
            options={option}
          />
        </div>
      </Grid>
      <VendorCrud
        biRef={biRef}
        showMessage={props.showMessage}
        setAlert={props.setAlert}
        context={props.context}
        onRefresh={vendorListRefresh}
      ></VendorCrud>
    </Grid>
  );
}
